import type { LucideIcon } from 'lucide-react'
import * as icons from 'lucide-react'
import { Colors } from './color'

type PascalToKebab<S extends string> = S extends `${infer T}${infer U}`
  ? U extends Uncapitalize<U>
    ? `${Lowercase<T>}${PascalToKebab<U>}`
    : `${Lowercase<T>}-${PascalToKebab<U>}`
  : S

type LucideIconExports = {
  [K in keyof typeof icons as typeof icons[K] extends LucideIcon ? K : never]: typeof icons[K]
}

// TODO: Add SAMANSA Icon (e.g. circle-pause-fill)
type Props = {
  name: PascalToKebab<keyof LucideIconExports>
  size?: number
  color?: keyof typeof Colors
}

// e.g. skip-back -> SkipBack
const kebabToPascal = (str: PascalToKebab<keyof LucideIconExports>): keyof LucideIconExports =>
  str
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('') as keyof LucideIconExports

export const Icon = ({ name, size = 20, color }: Props) => {
  const IconComponent = icons[kebabToPascal(name)]

  return <IconComponent size={size} color={color ? Colors[color] : undefined} />
}
